import { render } from "./realPersonDetail.vue?vue&type=template&id=1d0b5444&scoped=true"
import script from "./realPersonDetail.vue?vue&type=script&lang=js"
export * from "./realPersonDetail.vue?vue&type=script&lang=js"

import "./realPersonDetail.vue?vue&type=style&index=0&id=1d0b5444&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0b5444"]])

export default __exports__